import * as Phaser from "phaser-ce"
import { COLOR } from "../../common/Color"
import { FontType } from "../../common/TextUtils"
import { PhaserText } from "../utils/PhaserText"
import { Scale } from "../utils/Scale"
import { GenericAssets } from "./GenericAssets"

export class TitleSprite extends Phaser.Sprite {

    private titleText: Phaser.Sprite
    private readonly leftAligned: boolean
    private readonly group: Phaser.Group

    constructor(game: Phaser.Game, y: number, title: string, leftAligned = true, group?: Phaser.Group) {
        super(game, 0, y, (leftAligned ? GenericAssets.WHITE_BAR_LEFT : GenericAssets.WHITE_BAR))
        this.leftAligned = leftAligned
        this.group = group

        Scale.lockScaleSprite(this)

        if (!leftAligned) {
            this.x = Scale.width() - this.width
        }
        this.fixedToCamera = true

        if (group) {
            group.add(this)
        } else {
            this.game.add.existing(this)
        }
        this.addTitle(title)
    }

    addTitle = (title: string) => {
        if (this.titleText) {
            this.titleText.kill()
        }
        this.titleText = PhaserText.create(this.game, title, {
            x: this.x, y: this.y + Scale.height() * 0.02,
            type: FontType.TITLE, color: COLOR.darkGray, group: this.group
        })

        if (this.leftAligned) {
            this.titleText.x += Scale.width() * 0.02
        } else {
            this.titleText.x = Scale.width() * 0.98 - this.titleText.width
        }

        this.titleText.fixedToCamera = true
        this.titleText.setScaleMinMax(1, 1)
    }

    destroy() {
        this.titleText.destroy()
        super.destroy()
    }

}
